// Exported as a regular module so we can use it in a Vue plugin and within Vuex if needed
import axios from 'axios';

const axiosInstance = axios.create();

export default axiosInstance;
